mutation PromoteFromWaitlist($registrationId: ID!) {
  promoteFromWaitlist(input: { registrationId: $registrationId }) {
    registration {
      id
    }
    warnings
  }
}
